import img0 from "./assets/pexels-photo-172500.webp"
import img1 from "./assets/pexels-photo-1793037.webp"
import img2 from "./assets/pexels-photo-34327727.webp"
import img3 from "./assets/pexels-photo-913136.webp"
import img4 from "./assets/pexels-photo-672802.webp"
import img5 from "./assets/pexels-photo-1697902.webp"
export const images = [img0, img1, img2, img3, img4, img5]